import {useEffect, useState, useCallback} from '@wordpress/element';
import {getVideoThumbnails} from "../tools";

const useVideoThumbnails = (videoUrl, onSuccess) => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const memoizedOnSuccess = useCallback(onSuccess, []);

    useEffect(() => {
        if (!videoUrl) {
            setError(null);
            setIsLoading(false);
            return;
        }

        let isComponentMounted = true;

        const fetchAndProcessThumbnails = async () => {
            try {
                setIsLoading(true);
                setError(null);

                const result = await getVideoThumbnails(videoUrl);

                if (!isComponentMounted) return;

                if (result) {
                    const thumbnailData = {
                        service: result.service,
                        thumbnail: result.thumbnails[0].src,
                        srcset: result.thumbnails
                            .map(thumb => `${thumb.src} ${thumb.width}w`)
                            .join(', '),
                        sizes: result.thumbnails
                            .map(thumb => `(max-width: ${thumb.width}px) ${thumb.width}px`)
                            .join(', ')
                    };
                    memoizedOnSuccess?.(thumbnailData);
                } else {
                    setError('Unsupported video service for this URL.');
                }
            } catch (err) {
                if (isComponentMounted) {
                    setError(`Error while loading thumbnails: ${err.message}`);
                }
            } finally {
                if (isComponentMounted) {
                    setIsLoading(false);
                }
            }
        };

        fetchAndProcessThumbnails();

        return () => {
            isComponentMounted = false;
        };
    }, [videoUrl, memoizedOnSuccess]);

    return { error, isLoading };
};


export default useVideoThumbnails;